<div
  class="active-media"
  [ngClass]="{'draggable': zoomValue > 1}"
  xmlns=""
>
  <div class="active-media__container">
    @if (!playMedia && validSrc && imageUrl) {
      <img
        [src]="imageUrl"
        [alt]="'TRANS__ACTIVE_MEDIA__ACTIVE_MEDIA' | translate"
        id="mediaItem-{{activeMedia.artifact_id}}"
        (error)="setDefaultImg()"
      >
    }

    @if (!validSrc && activeMedia && activeMedia.object_type === 'Attachment') {
      <div class="default-image">
        <i class="icon-image-attention"></i>

        <span>
          {{ 'TRANS__ACTIVE_MEDIA__NO_ATTACHMENT_IMAGE' | translate }}
        </span>
      </div>
    }

    @if (is3DModel && playMedia) {
      <div class="model-3d-placeholder">
        <i class="icon-object"></i>
      </div>
    }

    @if (showPlayback) {
      @if (!playMedia) {
        <a
          (click)="onPlayMedia()"
          class="playButton"
        >
          <i class="icon-play2"></i>
        </a>
      }
      @else {
        <div class="player-max-size">
          @if (status === 'done') {
            <div>
              @if (activeMedia.object_type === 'Video') {
                <div class="dms-video">
                  @if (activeMedia?.dms_identifier; as dmsId) {
                    <div [attr.data-video-id]="dmsId">
                      <app-dms-video-player
                        [dmsApi]="getDmsApiUrl()"
                        [dmsIds]="dmsId">
                      </app-dms-video-player>
                    </div>
                  }
                </div>
              } @else if (activeMedia.object_type === 'Audio') {
                <audio
                  controls
                  autoplay
                >
                  @for (pu of activeMedia.$$mediaPlaybackUrls; track pu) {
                    <source
                      [src]="pu.url"
                      type="{{pu.type}}"
                    >
                  }
                </audio>
              }
            </div>
          }
          @else {
            <div class="default-image">
              <i class="icon-hour-glass"></i>

              <span>
                {{ 'TRANS__ACTIVE_MEDIA__MEDIA_NOT_READY' | translate }}
              </span>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
